import { render } from "./SetupScreen.vue?vue&type=template&id=9a7b4668"
import script from "./SetupScreen.vue?vue&type=script&lang=js"
export * from "./SetupScreen.vue?vue&type=script&lang=js"

import "./SetupScreen.vue?vue&type=style&index=0&id=9a7b4668&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__